import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import CheckboxField from 'components/application/CheckboxField';

export default function CheckboxCollection({
  checkBoxes,
  isDisabled,
  labelTextProps,
  mustSelect,
  nested,
  onChange,
}) {
  const checkedBoxes = checkBoxes.filter((checkbox) => checkbox.checked);
  const lastCheckedBox = checkedBoxes.length === 1 && checkedBoxes[0];

  return (
    <ul
      className={classNames(
        'checkbox-collection list-unstyled',
        nested && 'checkbox-collection--nested',
      )}
    >
      {checkBoxes.map((checkbox, index) => (
        <li className='checkbox-collection__item' key={index}>
          <CheckboxField
            additionalContent={checkbox.additionalContent}
            checked={checkbox.checked}
            disabled={
              isDisabled ||
              !!checkbox.disabled ||
              (mustSelect && checkbox === lastCheckedBox)
            }
            label={checkbox.label}
            labelTextProps={labelTextProps}
            name={checkbox.name}
            onChange={checkbox.onChange || onChange}
            renderNestedContent={checkbox.renderNestedContent}
            tooltip={checkbox.tooltip}
            tooltipAlignment={checkbox.tooltipAlignment}
            value={checkbox.value}
          />
        </li>
      ))}
    </ul>
  );
}

CheckboxCollection.propTypes = {
  checkBoxes: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  labelTextProps: PropTypes.object,
  nested: PropTypes.bool,
  isDisabled: PropTypes.bool,
};

CheckboxCollection.defaultProps = {
  isDisabled: false,
  mustSelect: false,
};
